export default "__VITE_ASSET__05ed0b37__"